import React from 'react'

import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText'
import Stack from '@mui/material/Stack'

import { Text } from '@mxenabled/mxui'

import { type DetailedBudget } from '../../../core'

import { formatCurrency } from '../../../core/utils/NumberFormatting'
import { BudgetDonut } from '../shared/BudgetDonut'

interface BudgetRowProps {
  budget: DetailedBudget
  onClick?: (budget: DetailedBudget) => void
}

export const BudgetRow: React.FC<BudgetRowProps> = ({ budget, onClick }) => {
  const {
    amount,
    budgetColors: { background, description: descriptionColor },
    category_guid,
    description,
    percentage,
    subBudgets,
    transaction_total,
  } = budget

  const overBudget = percentage > 100

  return (
    <ListItem>
      <ListItemButton onClick={() => onClick?.(budget)}>
        <BudgetDonut background={background} categoryGuid={category_guid} percentage={percentage} />
        <ListItemText
          primary={
            <Stack component="span" direction="row" justifyContent="space-between">
              <Text bold={true} variant="body1">
                {budget.category.name}
              </Text>
              <Text fontWeight={400} variant="body1">
                {`
                  ${formatCurrency(transaction_total, '0,0')} /
                  ${formatCurrency(amount, '0,0')}
                `}
              </Text>
            </Stack>
          }
          secondary={
            <Stack component="span" direction="row" justifyContent="space-between">
              <Text variant="caption">{`${subBudgets.length} Sub-budgets`}</Text>
              <Text
                bold={overBudget}
                sx={{
                  color: descriptionColor,
                  ...(overBudget && {
                    '.MuiListItemButton-root:hover &, .MuiListItemButton-root:active &': {
                      color: 'error.dark',
                    },
                  }),
                }}
                variant="caption"
              >
                {description}
              </Text>
            </Stack>
          }
        />
      </ListItemButton>
    </ListItem>
  )
}
